/**
 * Arrière-plan du portail : halos dérivants et filigrane de la marque.
 *
 * Un aplat de couleur, même juste, donne à un outil interne un air de page
 * d'erreur. Cette couche l'habite : trois halos aux couleurs de la charte — bleu
 * 2020, bleu Odice, rouge — et le pictogramme du groupe très effacé.
 *
 * Un composant plutôt que des pseudo-éléments sur `body`, pour trois raisons :
 *
 * 1. **plusieurs éléments distincts**, chacun avec sa taille, sa couleur et son
 *    cycle. `::before` et `::after` en offrent deux, et il en faut quatre ;
 * 2. **un seul propriétaire de l'arrière-plan.** Un pseudo-élément et un composant
 *    se disputant la même zone finissent en casse-tête d'empilement, où l'ordre
 *    dépend du moment où React monte ;
 * 3. **une image servie normalement.** Le filigrane est un `<img>` : le
 *    navigateur le met en cache et le charge en parallèle, là où un
 *    `background-image` en CSS attend l'analyse de la feuille de style.
 *
 * Rien ici n'est lisible ni cliquable : `aria-hidden` le retire des lecteurs
 * d'écran, `pointer-events: none` de la souris. Les animations sont neutralisées
 * par la préférence « moins d'animation », traitée globalement dans `index.css`.
 */

export function Backdrop() {
  return (
    <div aria-hidden="true" className="pointer-events-none fixed inset-0 -z-10 overflow-hidden">
      <span className="fond-halo fond-halo-1" />
      <span className="fond-halo fond-halo-2" />
      <span className="fond-halo fond-halo-3" />
      {/*
        Le pictogramme en couleur, et non la version blanche : ses trois pastilles
        rouge, cyan et marine restent reconnaissables sur les deux thèmes, là où le
        blanc disparaîtrait complètement en thème clair.
      */}
      <img src="/marque/odice-mark.png" alt="" className="fond-filigrane" />
    </div>
  );
}
